import { useMutation } from "@tanstack/react-query"
import { Form, Input } from "antd"
import { Button } from "components"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import NewModalWrapper from "components/new-stuff/ui/modals/NewModalWrapper"
import React, { useState } from "react"
import { paymentSchedulesService } from "services/paymentSchedulesService"
import { useAppNotificationStore } from "stores"
import getIdFromKey from "utils/getIdFromKey"
import { onQueryError } from "utils/utils"
type Props = {
  onClose: () => void
  invalidateQueries: () => void
  open: boolean
  paymentId: string
  x: string
  currency?: string
}

export const ReversePayment = ({
  onClose,
  open,
  paymentId,
  x,
  currency,
  invalidateQueries,
}: Props) => {
  const { toast } = useAppNotificationStore()
  const [comment, setComment] = useState("")
  const { isLoading: isSubmittingReverseAll, mutate: submitReverseAll } =
    useMutation({
      mutationFn: async (body: string) => {
        const data = await paymentSchedulesService.reverseItems(
          paymentId,
          body,
          currency
        )

        return data
      },
      onSuccess: (data) => {
        onClose()
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-reverse-success")
        invalidateQueries()
        setComment("")
      },
      onError: (e) => {
        onClose()
        setComment("")
        onQueryError(e)
      },
    })

  const { isLoading: isSubmittingReverseSingle, mutate: submitReverseSingle } =
    useMutation({
      mutationFn: async (body: string) => {
        const data = await paymentSchedulesService.reverseItem(
          paymentId,
          body,
          currency
        )

        return data
      },
      onSuccess: (data) => {
        onClose()
        setComment("")
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-reverse-success")
        invalidateQueries()
      },
      onError: (data: any) => {
        onClose()
        setComment("")
        onQueryError(data)
      },
    })

  return (
    <NewModalWrapper
      open={open}
      title={
        paymentId == getIdFromKey(x || "")
          ? "Reverse Payments"
          : "Reverse Payment"
      }
      className="w-[750px]"
      onClose={onClose}
    >
      <div className="px-5 py-3">
        <p className=" text-neutral300 mb-5 text-sm">
          {paymentId == getIdFromKey(x || "")
            ? `Only successful payments will be reversed. Provide reason to
                continue.`
            : `This payment will be deducted from future schedules for this beneficiary. Provide reason to continue.`}
        </p>
        <Form.Item
          name="reason"
          rules={[
            {
              required: true,
              message: "Please input your reason!",
            },
          ]}
        >
          <Input
            className="h-10 mb-5"
            placeholder="Reason"
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Item>
      </div>
      <div className="border py-5 px-6 flex gap-4 justify-end ">
        <Button
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          submitting={isSubmittingReverseAll || isSubmittingReverseSingle}
          disabled={comment == "" ? true : false}
          onClick={() => {
            mixPanelEvent("pay-schedule-payout-reverse-init")
            {
              paymentId == getIdFromKey(x || "")
                ? submitReverseAll(comment)
                : submitReverseSingle(comment)
            }
          }}
        >
          Reverse
        </Button>
      </div>
    </NewModalWrapper>
  )
}

export default ReversePayment
